<template>
    <v-tooltip top>
        <template v-slot:activator="{ on: tooltip }">
            <v-btn
                v-on="{ ...tooltip }"
                :disabled="model.status === 'inviato'"
                small
                :fab="params.fab ? params.fab : false"
                :icon="params.fab ? false : true"
                :color="params.button_color ? params.button_color : ''"
                :class="$vuetify.breakpoint.smAndDown ? 'mx-2' : 'mx-0'"
                @click.native.stop="openDialog()">
                <v-icon :size="$vuetify.breakpoint.smAndDown ? 28 : 24" :color="params ? params.color : ''">{{ params.icon }}</v-icon>

                <v-dialog v-model="show" max-width="500" persistent class="round-card" scrollable>
                    <v-card class="background-2 round-card">
                        <v-card-title class="pa-3">
                            <p class="pl-2 pl-xl-3">Invia in lavorazione</p>
                            <v-spacer></v-spacer>
                        </v-card-title>            
                        <v-divider></v-divider>

                        <v-card-text class="px-1 pb-1">

                            <v-container fluid :class="{'px-3': $vuetify.breakpoint.mdAndUp, 'px-0': $vuetify.breakpoint.smAndDown}" class="pt-6">
                                Vuoi inviare la lavorazione al macchinario?
                            </v-container>


                        </v-card-text>

                        <v-divider></v-divider>
                        
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn text color="info" @click.native.stop="closeDialog()">Annulla
                            </v-btn>
                            <v-btn text color="primary" @click.native.stop="createModel()" :loading="loading">Invia</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-btn>
        </template>
        <span>Invia</span>
    </v-tooltip>
</template>

<script>

    export default {
        name: 'generate-intervention-button',
        components: {
        },
        props: {
            model: Object,
            params: Object,
        },

        data() {
            return {
                show: false,
                loading: false,
            }
        },

        methods: {

            closeDialog() {
                this.show = false
            },

            openDialog() {
                this.show = true
            },

            createModel() {

                this.loading = true

                this.axios.post('machineprocesses/sendToMachinery/' + this.model.id).then(response => {
                    // get body data
                    this.show = false
                    this.loading = false
					this.$eventBusUtility.$emit('refreshTable_machineprocesses')
                    
                }, response => {

                })

            },      
        },
    }
</script>